/* Crunchy Fountain PDP + cart interactions */
(function () {
  'use strict';

  function money(cents) {
    var fmt = window.cfMoneyFormat || '${{amount}}';
    var withSep = function (n, dec) {
      var s = dec ? n.toFixed(2) : String(Math.round(n));
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    };
    var amount = cents / 100;
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withSep(amount, true))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withSep(amount, false))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(amount)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/<[^>]+>/g, '');
  }

  /* ---------------- gallery ---------------- */
  function initGallery(root) {
    var track = root.querySelector('[data-cf-track]');
    if (!track) return;
    var slides = track.children;
    var dots = root.querySelectorAll('[data-cf-dots] span');
    var thumbs = root.querySelectorAll('[data-cf-thumbs] button');

    function setActive(i) {
      dots.forEach && dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      thumbs.forEach && thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
    }
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      setActive(i);
    }, { passive: true });
    thumbs.forEach && thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.dataset.index, 10) || 0;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        setActive(i);
      });
    });
  }

  /* ---------------- buy box ---------------- */
  function initBuyBox(box) {
    var tiers = Array.prototype.slice.call(box.querySelectorAll('.cf-tile, .cf-tier:not([data-cf-addon])'));
    var priceEl = box.querySelector('[data-cf-price]');
    var compareEl = box.querySelector('[data-cf-compare]');
    var atcBtns = Array.prototype.slice.call(document.querySelectorAll('[data-cf-atc]'));
    var errEl = box.querySelector('[data-cf-atc-error]');
    var addon = box.querySelector('[data-cf-addon]');
    var stickyPrice = document.querySelector('[data-cf-sticky-price]');
    var stickyCompare = document.querySelector('[data-cf-sticky-compare]');
    var addUrl = box.dataset.cartAddUrl || '/cart/add';
    var cartUrl = box.dataset.cartUrl || '/cart';

    function currentTier() {
      return box.querySelector('.cf-tile.is-active') || box.querySelector('.cf-tier.is-active') || tiers[0];
    }

    function refresh() {
      var t = currentTier();
      if (!t) return;
      var price = parseInt(t.dataset.price, 10) || 0;
      var compare = parseInt(t.dataset.compare, 10) || 0;
      var units = parseInt(t.dataset.units, 10) || 1;
      if (units < 1) units = 1;
      var addonSelected = false;
      var addonAmt = 0;
      if (addon && addon.querySelector('input') && addon.querySelector('input').checked) {
        addonSelected = true;
        addonAmt = parseInt(addon.dataset.price, 10) || 0;
      }
      // Per-unit values (excluding addon — addon is flat, not per-unit)
      var eachPrice = Math.floor(price / units);
      var eachCompare = compare ? Math.floor(compare / units) : 0;
      var suffix = ' <span class="cf-cta__each">each</span>';
      if (priceEl) {
        priceEl.innerHTML = money(eachPrice) + suffix + (addonSelected ? ' <span class="cf-cta__addon">+ ' + money(addonAmt) + '</span>' : '');
      }
      if (compareEl) {
        compareEl.innerHTML = eachCompare > eachPrice ? (money(eachCompare) + ' each') : '';
      }
      if (stickyPrice) stickyPrice.innerHTML = money(eachPrice) + '<span class="cf-cta__each"> ea</span>';
      if (stickyCompare) stickyCompare.textContent = eachCompare > eachPrice ? money(eachCompare) : '';
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        tiers.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        refresh();
      });
    });
    var def = box.querySelector('.cf-tile[data-default]') || box.querySelector('.cf-tier[data-default]') || tiers[0];
    if (def) def.classList.add('is-active');
    if (addon) {
      var input = addon.querySelector('input');
      input && input.addEventListener('change', refresh);
    }
    refresh();

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.hidden = false;
    }

    function addToCart() {
      var t = currentTier();
      if (!t) return;
      var variantId = t.dataset.variantId;
      if (!variantId) { showError('This option is unavailable right now. Please refresh and try again.'); return; }
      var items = [{ id: parseInt(variantId, 10), quantity: parseInt(t.dataset.qty, 10) || 1 }];
      if (addon) {
        var input = addon.querySelector('input');
        var addonId = parseInt(addon.dataset.variantId, 10);
        if (input && input.checked && addonId) items.push({ id: addonId, quantity: 1 });
      }
      atcBtns.forEach(function (b) { b.setAttribute('disabled', ''); b.dataset.origHtml = b.innerHTML; b.textContent = 'Adding…'; });
      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart. Please try again.');
            return data;
          });
        })
        .then(function () {
          /* the drawer keeps them on the page; /cart stays the fallback when it is not mounted */
          if (window.CFDrawer && window.CFDrawer.open) {
            atcBtns.forEach(function (b) { b.removeAttribute('disabled'); if (b.dataset.origHtml) b.innerHTML = b.dataset.origHtml; });
            window.CFDrawer.open();
          } else {
            window.location.href = cartUrl;
          }
        })
        .catch(function (err) {
          showError(err.message || 'Could not add to cart. Please try again.');
          atcBtns.forEach(function (b) { b.removeAttribute('disabled'); if (b.dataset.origHtml) b.innerHTML = b.dataset.origHtml; });
        });
    }

    atcBtns.forEach(function (b) { b.addEventListener('click', addToCart); });

    /* sticky bar visibility */
    var sticky = document.querySelector('[data-cf-stickybar]');
    if (sticky && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      obs.observe(box);
    }

    /* delivery estimate */
    var d = box.querySelector('[data-cf-delivery-days]');
    if (d) {
      var days = parseInt(d.dataset.cfDeliveryDays, 10) || 5;
      var from = new Date(); from.setDate(from.getDate() + days);
      var to = new Date(); to.setDate(to.getDate() + days + 3);
      var fmt = { month: 'short', day: 'numeric' };
      d.textContent = from.toLocaleDateString('en-US', fmt) + ' – ' + to.toLocaleDateString('en-US', fmt);
    }
  }

  /* ---------------- cart page ---------------- */
  function initCart(root) {
    function busy(el) { el.style.opacity = '.5'; el.style.pointerEvents = 'none'; }

    root.querySelectorAll('[data-cf-qty]').forEach(function (q) {
      var line = parseInt(q.dataset.line, 10);
      var qty = parseInt(q.dataset.qty, 10);
      q.querySelector('[data-minus]').addEventListener('click', function () { change(line, qty - 1, q); });
      q.querySelector('[data-plus]').addEventListener('click', function () { change(line, qty + 1, q); });
    });
    root.querySelectorAll('[data-cf-remove]').forEach(function (b) {
      b.addEventListener('click', function () { change(parseInt(b.dataset.line, 10), 0, b); });
    });

    function change(line, quantity, el) {
      busy(root);
      fetch((window.routes && window.routes.cart_change_url || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) }),
      }).then(function () { window.location.reload(); });
    }

    root.querySelectorAll('[data-cf-upsell-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = parseInt(b.dataset.variantId, 10);
        if (!id) return;
        b.textContent = 'Adding…';
        fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.reload();
        }).catch(function () { b.textContent = 'Try again'; });
      });
    });
  }

  /* ---------------- scroll reveal ---------------- */
  function initReveal() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.Shopify && Shopify.designMode) return;
    var targets = document.querySelectorAll(
      '.cf-sechead, .cf-dive, .cf-feature, .cf-problem__card, .cf-hs__panel, .cf-hs__chip, ' +
      '.cf-own__card, .cf-own__photo, .cf-num__item, .cf-num__media, .cf-stats > div, .cf-guarantee'
    );
    var pending = [];
    function show(el) { el.classList.add('is-in'); }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { show(e.target); obs.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px 12% 0px', threshold: 0.01 });
    targets.forEach(function (t) {
      if (t.classList.contains('cf-reveal')) return;
      t.classList.add('cf-reveal');
      var sibs = t.parentElement ? Array.prototype.indexOf.call(t.parentElement.children, t) : 0;
      t.style.transitionDelay = Math.min(sibs * 45, 135) + 'ms';
      obs.observe(t);
      pending.push(t);
    });
    /* safety sweep: fast scrolls can outrun the observer — anything whose top
       has entered (or passed) the viewport gets revealed and dropped */
    function sweep() {
      pending = pending.filter(function (t) {
        if (t.classList.contains('is-in')) return false;
        var top = t.getBoundingClientRect().top;
        if (top < window.innerHeight + 60) { show(t); obs.unobserve(t); return false; }
        return true;
      });
      if (!pending.length) {
        window.removeEventListener('scroll', onScroll);
      }
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      setTimeout(function () { ticking = false; sweep(); }, 250);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    sweep();
  }

  /* ---------------- generic snap rail + dots ----------------
     Any [data-cf-rail] whose next sibling is [data-cf-raildots] gets one dot
     per slide, kept in sync with scroll position. Dots are hidden by CSS above
     the mobile breakpoint, so desktop grids are untouched. */
  function initRail(rail) {
    if (rail.dataset.cfRailReady) return;
    var dots = rail.parentNode && rail.parentNode.querySelector('[data-cf-raildots]');
    var slides = Array.prototype.slice.call(rail.children);
    if (!dots || slides.length < 2) return;
    rail.dataset.cfRailReady = '1';

    dots.innerHTML = '';
    slides.forEach(function (_, i) {
      var d = document.createElement('span');
      if (i === 0) d.className = 'is-active';
      dots.appendChild(d);
    });
    var marks = Array.prototype.slice.call(dots.children);

    function nearest() {
      var mid = rail.scrollLeft + rail.clientWidth / 2;
      var best = 0, bestD = Infinity;
      slides.forEach(function (s, i) {
        var c = s.offsetLeft + s.offsetWidth / 2;
        var d = Math.abs(c - mid);
        if (d < bestD) { bestD = d; best = i; }
      });
      return best;
    }
    rail.addEventListener('scroll', function () {
      var i = nearest();
      marks.forEach(function (m, j) { m.classList.toggle('is-active', j === i); });
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('[data-cf-rail]').forEach(initRail);
    document.querySelectorAll('[data-cf-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-cf-buybox]').forEach(initBuyBox);
    document.querySelectorAll('[data-cf-cart]').forEach(initCart);
    initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
